import { useState } from "react";
import { useDeleteTaskDuration } from "../../../hooks/task-duration";
import { TaskDuration } from "../../../models";
import { GenericDataGrid } from "../generic-grid/Generic.grid";
import { taskDurationColumns as columns } from "./task-duration.columns";
import { TaskDurationForm } from "../../forms";
import { ModalContainerChangeDetection } from "../../ui";

interface Props<T> {
  rows: T[];
  loading: boolean;
  onClick?: (entity: T) => void;
  onLink?: (entity: T) => void;
  onModalClosed?: () => void;
  title?: string;
  autoHeight?: boolean;
  disableColumnsButton?: boolean;
  disableExport?: boolean;
  disableQuickFilter?: boolean;
  disableCreate?: boolean;
}

export const TaskDurationDataGrid = (props: Props<TaskDuration>) => {
  const {
    rows,
    loading,
    onClick,
    onLink,
    onModalClosed,
    title,
    autoHeight,
    disableColumnsButton,
    disableExport,
    disableQuickFilter,
    disableCreate,
  } = props;
  const [taskDuration, setTaskDuration] = useState<TaskDuration>();
  const [openModal, setOpenModal] = useState(false);
  const { mutate: deleteTaskDuration } = useDeleteTaskDuration();

  const onEditCreate = (taskDuration?: TaskDuration) => {
    taskDuration ? setTaskDuration(taskDuration) : setTaskDuration(undefined);
    setOpenModal(true);
  };

  return (
    <GenericDataGrid
      rows={rows}
      columns={columns}
      loading={loading}
      onClick={onClick}
      onDelete={(taskDuration) => deleteTaskDuration(taskDuration.id)}
      onCreate={onEditCreate}
      onEdit={onEditCreate}
      onLink={onLink}
      title={title}
      createTitle="Create Task Duration"
      deleteTitle="Do you want to delete this Task Duration"
      ignoreFields={["id", "createdTimestamp", "modifiedTimestamp"]}
      initialState={{
        sorting: {
          sortModel: [{ field: "name", sort: "asc" }],
        },
      }}
      disableColumnsButton={disableColumnsButton}
      disableExport={disableExport}
      disableQuickFilter={disableQuickFilter}
      disableCreate={disableCreate}
      autoHeight={autoHeight}
    >
      <ModalContainerChangeDetection
        open={openModal}
        handleClose={() => {
          setOpenModal(false);
          onModalClosed && onModalClosed();
        }}
        title={`${taskDuration ? "Edit" : "Create"} Task Duration`}
      >
        <TaskDurationForm
          onSubmitted={() => setOpenModal(false)}
          taskDuration={taskDuration}
        />
      </ModalContainerChangeDetection>
    </GenericDataGrid>
  );
};
